import { Col, Row, Modal, Card } from "antd";
import { TEST_RIDE_SUMMARY } from "../../../../Common/Grafana/Constants";
import { useEffect, useState } from "react";
import { EyeOutlined } from "@ant-design/icons";
import ChartFilter from "../../../../Common/ChartFilter";
import GetIframe from "../../../../Common/Grafana/GetIframe";

const FullGraphsModal = ({
  modalTitle,
  baseUrl,
  chartList,
  baseFilterObject,
  variableKeys
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });

  useEffect(() => {
    setChartType({ timeSeries: true, histogram: false, boxPlot: false });
  }, []);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <div onClick={handleOpen} className="align-center cursor-pointer">
        <EyeOutlined className="mr05" />
        Details
      </div>
      <Modal
        title={modalTitle}
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        className="full-view-graph-modal"
        footer={null}
        width="100%"
        height="100%"
        style={{ top: 0 }}
        styles={{ body: { height: "calc(100vh - 75px)" } }}
      >
        <Row className="grafana-compare">
          <Col span={24}>
            <Card
              title={
                <Row justify="end">
                  <Col span={4}>
                    <ChartFilter
                      updateChartType={updateChartType}
                      chartType={chartType}
                    />
                  </Col>
                </Row>
              }
            >
              {chartList.map((chart, index) => (
                <Row key={index} gutter={[16, 16]} className="mt05">
                  {chartType?.timeSeries ? (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      flex={3}
                      id={"timeSeries-" + chart.toLowerCase()}
                    >
                      <GetIframe
                        title={"Time Series - " + chart}
                        url={baseUrl}
                        panelId={
                          TEST_RIDE_SUMMARY.PANEL_ID[chart]["timeSeries"]
                        }
                        variableObject={baseFilterObject}
                        variableKeys={variableKeys}
                        width="100%"
                        height="250"
                        divId={"timeSeries-" + chart.toLowerCase()}
                      />
                    </Col>
                  ) : null}
                  {chartType?.histogram ? (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      flex={"auto"}
                      id={"histogram-" + chart.toLowerCase()}
                    >
                      <GetIframe
                        title={"Histogram - " + chart}
                        url={baseUrl}
                        panelId={TEST_RIDE_SUMMARY.PANEL_ID[chart]["histogram"]}
                        variableObject={baseFilterObject}
                        variableKeys={variableKeys}
                        width="100%"
                        height="250"
                        divId={"histogram-" + chart.toLowerCase()}
                      />
                    </Col>
                  ) : null}
                  {chartType?.boxPlot ? (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      flex={"auto"}
                      id={"boxPlot-" + chart.toLowerCase()}
                    >
                      <GetIframe
                        title={"BoxPlot - " + chart}
                        url={baseUrl}
                        panelId={TEST_RIDE_SUMMARY.PANEL_ID[chart]["boxPlot"]}
                        variableObject={baseFilterObject}
                        variableKeys={variableKeys}
                        width="100%"
                        height="250"
                        divId={"boxPlot-" + chart.toLowerCase()}
                      />
                    </Col>
                  ) : null}
                </Row>
              ))}
            </Card>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default FullGraphsModal;
